import { styled } from '@mui/material';

import WsColors from '../../WsColors';
import { Item } from '../Item';

const EmailTextBorder = styled(Item)(({ theme }) => ({
  borderTop: '1px solid ' + WsColors.TertiaryShades100,
  borderRadius: 0,
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
}));

export default EmailTextBorder;
